<app-route-list [kpiData]="routeList" [selectedKPIRoutes]="[]" [isSelectionEnable]="false"
    [loading]="loading"></app-route-list>